import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import { login, forgotPassword } from "../../actions/AuthActions";
import { actionChangeAppProps } from "../../actions/AppAction";
import RaisedButton from "material-ui/RaisedButton";
import FlatButton from "material-ui/FlatButton";
import Paper from "material-ui/Paper";
import Username from "material-ui/svg-icons/social/person";
import Send from "material-ui/svg-icons/content/send";
import { required, validateEmail } from "../../common/validaciones";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Util, { SUCCESS } from "../../common/Util";
import { LOGIN } from "../../config/RoutesConstants";
import CircularProgress from "material-ui/CircularProgress";

class PasswordRecovery extends Component {
	constructor(props) {
		super(props);
		this.state = {
			state: "estado",
			error: "",
			open: false,
			loading: false
		};
		this.comeBack = this.comeBack.bind(this);
	}

	onSubmit(formValues) {
		//Aca deberia realizar la recuperacion del email
		this.setState({ error: "", loading: true });
		this.props.forgotPassword(
			formValues.email,
			this.forgotPasswordSucces.bind(this)
		);
	}
	forgotPasswordSucces(value) {
		if (value) {
			this.setState({ loading: false });
			Util.showNoty(
				SUCCESS,
				"Se envio un email para cambiar su contraseña. Revise su email."
			);
			this.comeBack();
		} else {
			this.setState({
				error: "El email ingresado no es correcto.",
				loading: false
			});
		}
	}
	comeBack() {
		this.props.history.push(LOGIN);
	}
	renderConditionalLoading(loading) {
		if (loading) {
			return (
				<div
					style={{
						padding: 15,
						justifyContent: "center",
						alingItems: "center"
					}}
				>
					<CircularProgress />
				</div>
			);
		} else {
			return (
				<div>
					<RaisedButton
						label="Restablecer Contraseña"
						type="submit"
						primary={true}
						fullWidth
						className="top20"
						style={{ height: 40 }}
						icon={<Send />}
					/>
					<FlatButton
						label="Cancelar"
						onClick={this.comeBack}
						secondary={true}
						fullWidth
						className="top05 flatLinkButton"
					/>
				</div>
			);
		}
	}
	render() {
		const { handleSubmit } = this.props;
		return (
			<div className="screen-login">
				<Paper
					style={{
						flex: 1
					}}
					className="bg-login columns-column-between padding20"
				>
					<div>
						<form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
							<ReactCSSTransitionGroup
								transitionName="loginanim"
								transitionAppear={true}
								transitionAppearTimeout={1000}
								transitionEnter={false}
								transitionLeave={false}
							>
								<div className="container-login top100">
									<Paper className="paper-login">
										<div className="fields-login">
											<h1 className="bottom0" style={{}}>
												Restablecer Contraseña
											</h1>
										</div>
										<div className="fields-login">
											<Username style={{ marginRight: 10, color: "#ccc" }} />
											<Field
												component={TextField}
												className="textField"
												name="email"
												type="text"
												fullWidth
												hintText="Email"
												floatingLabelText="Email"
												validate={[required, validateEmail]}
											/>
										</div>
										<div
											style={{ color: "red", paddingLeft: 20, paddingTop: 25 }}
										>
											{this.state.error}
										</div>
										{this.renderConditionalLoading(this.state.loading)}
									</Paper>
								</div>
							</ReactCSSTransitionGroup>
						</form>
					</div>
					<div className="text-right version-login">Versión 0.9</div>
				</Paper>
			</div>
		);
	}
}
function mapStateToProps(store) {
	return {
		loginForm: store.app.login,
		rol: store.app.rol,
		active: store.app.active
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			login,
			actionChangeAppProps,
			forgotPassword
		},
		dispatch
	);
}
export default reduxForm({
	form: "PasswordRecovery"
})(withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordRecovery)));



// WEBPACK FOOTER //
// ./src/screens/login/PasswordRecovery.js